<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">List</span>
        <h3 class="page-title">Gereja</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
              <button type="button" class="btn-primary btn-sm" @click="add()" style="padding:0.15rem 0.5rem !important">Tambah Baru</button>
          </div>
          <div class="card-body p-0 pb-3 text-center" style="overflow-x:scroll">
            <d-row style="margin:auto">
            <d-col md="4"  class="form-group" style="text-align:left">
              Menampilkan
              <select v-model="ipp" >
                <option value=5 selected>5 item</option>
                <option value=10>10 item</option>
                <option value=15>15 item</option>
                <option value=20>20 item</option>
                <option value=0>Semua</option>
              </select>
            </d-col>
            <d-col md="4"  class="form-group">
            </d-col>
            <d-col md="4"  class="form-group">
              <d-form-input type="text" id="feInputAddress" placeholder="Search" v-model.trim="search" />
            </d-col>
            </d-row>
        <b-table
            :data="isEmpty ? [] : data"
            :loading="loading"
            :mobile-cards="hasMobileCards"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            :current-page="page"
            @page-change="onPageChange"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" sortable>
                    <button type="button" class="btn-primary btn-sm" @click="open_data(props.row.id)" style="padding:0.15rem 0.5rem !important"><i class="material-icons">edit</i></button>
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                </b-table-column>
                <b-table-column field="name" label="Name" sortable>
                    {{ props.row.name }}
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';

    export default {
        data() {
            return {
                data:[],
                list:[],
                index:0,
                images:[],
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: true,
                sortField:'name',
                sortOrder:'asc',
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                sort:'name',
                defaultSortOrder:'asc',
                page:1,
                perPage:5,
                total:2,
                filename:'',
                ipp:5,
                search:'',
            }
        },
        watch:{
          ipp(){
           if (this.ipp>0) this.perPage=this.ipp*1
           else this.perPage=this.total*1
           this.update_data();
          },
          search(){
           if(this.search.length>2||!this.search.length)this.update_data()
          },
        },
        methods:{
          add(id){
            this.$router.push({name:'church-form',params:{id:0},query:{id:0}});
          },
          open_data(id){
            this.$router.push({name:'church-form',params:{id:id},query:{id:id}});
          },
          save_state(){
            var arr={
              page:this.page,
              perPage:this.perPage,
              total:this.total,
              ipp:this.ipp,
              search:this.search,
              sortField:this.sortField,
              sortOrder:this.sortOrder,
            };
            this.$store.commit('list',arr);
          },
          load_state(){
            var arr=this.$store.state.list;
            if ( arr==null ) return;
            this.page=arr.page;
            this.perPage=arr.ipp>0 ? arr.perPage : arr.total;
            this.total=arr.total;
            this.ipp=arr.ipp;
            this.search=arr.search;
            this.sortField=arr.sortField;
            this.sortOrder=arr.sortOrder;
          },
          onPageChange(page){
           this.page=page;
           this.update_data();           
          },
          onSort(field,order){
           if ( !this.loading ){           
            this.sortField=field;
            this.sortOrder=order;
            this.update_data();
           }
          },
          update_data(){
           this.loading=true;           
           this.save_state();
           this.axios.post( env.server+'/church-list',{
             start: this.page,
             length: this.perPage>0 ? this.perPage: this.total,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.total=resp.data.data.total_results;
               for (var i=0; i<this.data.length; i++ ){
                 this.data[i].idx=i;
               }
             }
           );
          },
        },
        mounted(){
          this.load_state();
          this.update_data();
        },
    }
</script>
